import { REFACTOR_URL } from '../../../helpers/env'
import { API_URL } from '../constants'

export interface ITaskFilters {
  isOpen?: boolean
  centerId?: number
  name?: string
  priority?: string
  search?: string
  /** Ne rend que les tâches dont la cause a disparu (`false`), ou tient (`true`). */
  causeStillHolds?: boolean
}

const buildQuery = (
  size: number,
  page: number,
  filters: ITaskFilters,
  sort: { field: string; sort: string } | null,
): string => {
  const parts: string[] = [`page=${page}`, `limit=${size}`]

  // Les booléens se testent sur `undefined` et non sur leur valeur : `false`
  // est une valeur de filtre légitime — « cause levée » en dépend entièrement.
  if (filters.isOpen !== undefined) parts.push(`isOpen=${filters.isOpen}`)
  if (filters.causeStillHolds !== undefined)
    parts.push(`causeStillHolds=${filters.causeStillHolds}`)
  if (filters.centerId !== undefined) parts.push(`centerId=${filters.centerId}`)
  if (filters.name) parts.push(`name=${encodeURIComponent(filters.name)}`)
  if (filters.priority) parts.push(`priority=${filters.priority}`)
  if (filters.search) parts.push(`search=${encodeURIComponent(filters.search)}`)
  if (sort) parts.push(`sort=${sort.field}&order=${sort.sort}`)

  return parts.join('&')
}

const parameters = (token: string): RequestInit => ({
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Host: `${API_URL}`,
    Authorization: `Bearer ${token}`,
  },
  mode: 'cors',
})

const appeler = (endpoint: RequestInfo, token: string) => {
  let status = 0
  return fetch(endpoint, parameters(token))
    .then((response) => {
      status = response.status
      return response.json()
    })
    .then((data) => ({ data, status }))
    .catch((e) => {
      console.log(e)
    })
}

export const tasksByPageService = async (
  token: string,
  size: number,
  page: number,
  filters: ITaskFilters,
  sort: { field: string; sort: string } | null,
) =>
  appeler(
    `${REFACTOR_URL}/user-task?${buildQuery(size, page, filters, sort)}`,
    token,
  )

export const taskSummaryService = async (token: string) =>
  appeler(`${REFACTOR_URL}/user-task/summary`, token)

const envoyer = (
  endpoint: RequestInfo,
  token: string,
  method: 'PATCH' | 'POST',
  corps: Record<string, unknown>,
) => {
  let status = 0
  return fetch(endpoint, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Host: `${API_URL}`,
      Authorization: `Bearer ${token}`,
    },
    mode: 'cors',
    body: JSON.stringify(corps),
  })
    .then((response) => {
      status = response.status
      return response.json()
    })
    .then((data) => ({ data, status }))
    .catch((e) => {
      console.log(e)
    })
}

export const transitionTaskService = async (
  token: string,
  id: string,
  status: 'DONE' | 'REJECTED',
  comment?: string,
) =>
  envoyer(`${REFACTOR_URL}/user-task/${id}/transition`, token, 'PATCH', {
    status,
    // Le champ est facultatif côté API ; ne pas l'envoyer vide, `@IsString`
    // accepterait la chaîne vide et écrirait un commentaire creux.
    ...(comment ? { comment } : {}),
  })

export const commentTaskService = async (
  token: string,
  id: string,
  comment: string,
) =>
  envoyer(`${REFACTOR_URL}/user-task/${id}/comment`, token, 'POST', { comment })

export const bulkCloseTasksService = async (token: string, ids: string[]) =>
  envoyer(`${REFACTOR_URL}/user-task/bulk-close`, token, 'PATCH', { ids })
